exports.install = function (Vue, options) {
  /*
   *   保留两位小数
   * */
  Vue.prototype.toDecimal2 = function (str){
    var f = parseFloat(str);
    if (isNaN(f)) {
      return 0;
    }
    var f = Math.round(str*100)/100;
    var s = f.toString();
    var rs = s.indexOf('.');
    if (rs < 0) {
      rs = s.length;
      s += '.';
    }
    while (s.length <= rs + 2) {
      s += '0';
    }
    return s;
  };

// 数组中是否包含元素
  Vue.prototype.objectContainOfArray = function(spArray,spObjct){
    for (let i in spArray) {
      if (spArray[i] == spObjct) return true;
    }
    return false;
  };

  // 数组中元素下标
  Vue.prototype.indexOfcontractionDataForID = function(spArray,spObjct){
    for (let i in spArray) {
      if (spArray[i].id == spObjct) return i;
    }
  };




};




//////////////////
// WEBPACK FOOTER
// ./static/js/base.js
// module id = Qfcr
// module chunks = 1